import { styled } from '@mui/material/styles';
import { Box, TableContainer, TableCell, TableRow, Button } from '@mui/material';

export const TableWrapper = styled(Box)<{ maxWidth?: string }>(({ maxWidth }) => ({
  width: '100%',
  maxWidth: maxWidth || '100%',
  padding: '16px',
  fontFamily: "'Lato', sans-serif",
}));

export const StyledTableContainer = styled(TableContainer)(({ theme }) => ({
  borderRadius: '8px',
  border: '1px solid #e0e0e0',
  backgroundColor: '#ffffff',
  boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.1)',
  '& .MuiTable-root': {
    borderCollapse: 'separate',
    borderSpacing: 0,
  },
}));

export const StyledTable = styled('table')(({ theme }) => ({
  width: '100%',
  borderCollapse: 'separate',
  borderSpacing: 0,
}));

export const StyledTableCell = styled(TableCell)(({ theme }) => ({
  fontSize: '12px',
  fontFamily: "'Lato', sans-serif",
  fontWeight: 400,
  color: 'rgba(0, 0, 0, 0.8)',
  padding: '12px 16px',
  borderBottom: '1px solid #e0e0e0',
  textAlign: 'center',
  '&:first-of-type': {
    borderLeft: 'none',
  },
  '&:last-of-type': {
    borderRight: 'none',
  },
  [theme.breakpoints.down('sm')]: {
    fontSize: '11px',
    padding: '8px 12px',
  },
}));

export const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:hover': {
    backgroundColor: '#f5f5f5',
  },
  '&:last-child td': {
    borderBottom: 'none',
  },
  '&.alternate': {
    backgroundColor: '#f9f9f9',
  },
}));

export const StyledHeaderCell = styled(StyledTableCell)(({ theme }) => ({
  backgroundColor: '#E7EFF5',
  fontWeight: 700,
  color: 'rgba(0, 0, 0, 0.8)',
  borderBottom: '2px solid #d0d0d0',
  position: 'sticky',
  top: 0,
  zIndex: 1,
})); 